// See here for this hacky comment:
// https://stackoverflow.com/questions/60528893/tailwind-css-styling-not-being-applied-on-deploy
/**
 * PurgeCSS:
 * text-hakimo-yellow
 * stroke-hakimo-yellow
 * fill-hakimo-yellow
 * text-status-red
 * stroke-status-red
 * text-status-blue
 * stroke-status-blue
 * fill-status-blue
 * text-status-cyan
 * stroke-status-cyan
 * fill-status-cyan
 * text-status-green
 * stroke-status-green
 * text-status-orange
 * stroke-status-orange
 * text-status-emerald
 * stroke-status-emerald
 * text-primary-700
 * stroke-primary-700
 */
export function getMarkerColor(color?: string) {
  switch (color) {
    case 'yellow':
      return 'hakimo-yellow';
    case 'red':
      return 'status-red';
    case 'blue':
      return 'status-blue';
    case 'cyan':
      return 'status-cyan';
    case 'green':
      return 'status-green';
    case 'orange':
      return 'status-orange';
    case 'emerald':
      return 'status-emerald';
    default:
      return 'primary-700';
  }
}

export const formatTime = (
  date: Date,
  timeZone: string,
  showTimezoneName?: boolean
) => {
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: timeZone,
    timeZoneName: showTimezoneName ? 'short' : undefined,
  });
};
